<template>
  <div class="card py-2 px-3 mb-1">
    <div class="d-flex justify-content-between align-items-center">
      <div>
        <div style="font-weight: 600">
          {{ assessment.firstName }} {{ assessment.lastName }} - Tutor:
          {{ assessment.tutorFirstName }} {{ assessment.tutorLastName }}
        </div>
        <div>
          <span class="mr-2" style="text-transform: capitalize"
            >Subject: {{ assessment.subject }}</span
          >
          Year Level: {{ assessment.yearLevel || "Prep" }}
        </div>
      </div>

      <div v-if="deleted === false">
        <a
          @click="downloadReport()"
          href="#"
          class="ml-3"
          style="font-weight: 600"
          v-if="assessment.tutorSubmittedAt"
          >REPORT</a
        >
        <a
          @click="downloadWorksheet()"
          href="#"
          class="ml-3"
          style="font-weight: 600"
          v-if="assessment.tutorSubmittedAt"
          >WORKSHEETS</a
        >
        <a
          class="ml-3"
          :href="'/dashboard/create-assessment?id=' + assessment._id"
          style="font-weight: 600"
          v-if="!assessment.tutorSubmittedAt"
          >EDIT</a
        >
        <a
          @click="deleteAssessment()"
          href="#"
          class="ml-3"
          style="font-weight: 600"
          >DELETE</a
        >
      </div>
      <div v-if="deleted === true">DELETED</div>
    </div>
  </div>
</template>

<script>
import { saveAs } from "file-saver";
export default {
  props: ["assessment"],
  data() {
    return {
      deleted: false,
    };
  },
  methods: {
    downloadWorksheet() {
      this.$_viewWorksheetsModal(this.assessment._id);
    },
    deleteAssessment() {
      this.axios
        .delete(
          `${process.env.VUE_APP_API_URL}/api/assessments/${this.assessment._id}`
        )
        .then((res) => {
          this.deleted = true;
          this.$root.$emit("popup", "Assessment successfully deleted.");
        });
    },
    downloadReport() {
      this.axios
        .get(
          `${process.env.VUE_APP_API_URL}/api/assessments/${this.assessment._id}?report=true`,
          { responseType: "blob" }
        )
        .then((res) => {
          console.log(res.data);
          const blob = new Blob([res.data], { type: "text/html" });
          saveAs(blob, "report.html");
        })
        .catch(() => {
          this.error = true;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    downloadWorksheets() {
      // this is running very slow, need to optimize the method on server side
      this.loading = true;
      this.axios
        .get(
          `${process.env.VUE_APP_API_URL}/api/assessments/${this.assessment._id}?worksheets=true`,
          { responseType: "blob" }
        )
        .then((res) => {
          const blob = new Blob([res.data], { type: "application/zip" });
          saveAs(blob, "worksheets.zip");
        })
        .catch(() => {
          this.error = true;
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
};
</script>

<style></style>
